import { Guesses } from "../Guesses";
import { Panel } from "./Panel";
import React from "react";
import { PobleCV } from "../PobleCV";
import { formatDistance } from "../../domain/geography";
import { SettingsData } from "../../hooks/useSettings";
import { Twemoji } from "react-emoji-render";

interface InfosProps {
  isOpen: boolean;
  close: () => void;
  settingsData: SettingsData;
}

export function Infos({ isOpen, close, settingsData }: InfosProps) {
  return (
    <Panel title="Com es juga?" isOpen={isOpen} close={close}>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
        <div>
          Endevina el <PobleCV />. Tens sis intents.
        </div>
        <div>Cada vegada que ho intentes, introdueix el topònim en valencià d'un poble o d'una ciutat de la Comunitat Valenciana.</div>
        <div>
          Després de cada intent, veuràs la distància, la direcció i la proximitat de la teua opció respecte de la resposta correcta.
        </div>
      </div>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
        <div className="font-bold">Exemples</div>
        <div>
          <Guesses
            rowCount={1}
            guesses={[
              {
                name: "Ibi",
                direction: "NE",
                distance: 207_000,
              },
            ]}
            settingsData={settingsData}
          />
          <div className="my-2">
            Has respost <span className="uppercase font-bold">Ibi</span>, que es troba a {" "}
            {formatDistance(207000, settingsData.distanceUnit)} de la localitat que has d'endevinar. El municipi correcte està situat al 
            nord-est <Twemoji text="↗️" options={{ className: "inline-block" }} /> (prenent Ibi com a referència).
            Per consegüent, has obtingut un 35% en la puntuació de proximitat. Estàs a anys llum!
          </div>
        </div>
        <div>
          <Guesses
            rowCount={1}
            guesses={[
              {
                name: "Sagunt",
                direction: "NE",
                distance: 87_000,
              },
            ]}
            settingsData={settingsData}
          />
          <div className="my-2">
          T'hi estàs acostant! El municipi que busquem es troba a {formatDistance(87000, settingsData.distanceUnit)}{" "}
          al nord-est de <span className="uppercase font-bold"> Sagunt</span>. Has aconseguit una puntuació del 72%.
          </div>
        </div>
        <div>
          <Guesses
            rowCount={1}
            guesses={[
              {
                name: "Ares del Maestrat",
                direction: "N",
                distance: 0,
              },
            ]}
            settingsData={settingsData}
          />
          <div className="my-2">
          Ara sí que sí, l'opció <span className="uppercase font-bold">Ares del Maestrat</span> és la localitat escollida. Ben fet!{" "}
            <Twemoji text="🎉" options={{ className: "inline-block" }} />
          </div>
        </div>
      </div>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3 font-bold">
        Recorda que cada dia hi ha un nou <PobleCV />.
      </div>
      <div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
        <PobleCV /> és una idea inspirada de manera directa en {" "}
        <a
          className="underline"
          href="https://worldle.teuteuf.fr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Worldle
        </a>{" "}
        creat per{" "}
        <a
          className="underline"
          href="https://twitter.com/teuteuf"
          target="_blank"
          rel="noopener noreferrer"
        >
          @teuteuf
        </a>
        , segons l'adaptació de {" "}
        <a
          className="underline"
          href="https://poble.joanfont.cat/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Poble
        </a>{" "}
        creat per{" "}
        <a
          className="underline"
          href="https://twitter.com/joanfont"
          target="_blank"
          rel="noopener noreferrer"
        >
          @joanfont
        </a>
        .
      </div>
      <div className="space-y-3 text-justify pb-3">
        <div>
          Fet per {" "}
          <a
            className="underline"
            href="https://www.apuntmedia.es/"
            target="_blank"
            rel="noopener noreferrer"
          >
            À Punt Mèdia
          </a>{" "}
        </div> 
      </div>
    </Panel>
  );
}
